// Auto-generated from the Schwartz Pochapin guest list CSV.
// Each entry is one invitation party; names are as they should appear on the RSVP form.
const guestGroups = [
  [
    "Rachel Aboodi",
    "Jack Tauber"
  ],
  [
    "Rachel Ain",
    "David Levy"
  ],
  [
    "Sara Amsalem",
    "Jamie Tanzer"
  ],
  [
    "Portia Antrobus",
    "Josh"
  ],
  [
    "Robin Arzt",
    "Larry Nadell"
  ],
  [
    "Andrew Baker"
  ],
  [
    "Allie Bannett",
    "Zev Bannett"
  ],
  [
    "Stu Barenholtz",
    "Liz Barenholtz"
  ],
  [
    "Sharon Bensadigh"
  ],
  [
    "Bill Bergan",
    "Fran Bergan"
  ],
  [
    "Diane Berson"
  ],
  [
    "Ryan Bichoupan",
    "Amanda Haimm"
  ],
  [
    "Margie Bissinger",
    "Craig Bissinger"
  ],
  [
    "Hillary Bissinger",
    "Josh Bissinger"
  ],
  [
    "Lauren Bissinger",
    "Scott Bissinger"
  ],
  [
    "Zachary Borine",
    "Sophie Savas-Carstens"
  ],
  [
    "Jennifer Capon",
    "Guest"
  ],
  [
    "Tim Chartier",
    "Ella Chartier"
  ],
  [
    "Chagi Chesir",
    "Molly Heller"
  ],
  [
    "James Chiarelli",
    "Jamie Chiarelli",
    "Josephine Chiarelli",
    "Albert Chiarelli"
  ],
  [
    "Austin Chrislock",
    "Zoe Curtis"
  ],
  [
    "Susan Geary",
    "Matthew Cohen"
  ],
  [
    "Steven Cohen",
    "Susan Cohen"
  ],
  [
    "Thomas Connolly",
    "Karen Connolly"
  ],
  [
    "Conrad de Menil"
  ],
  [
    "Weston Deutchlander",
    "Shaun Deutchlander"
  ],
  [
    "Mikey Englard",
    "Tyler Englard"
  ],
  [
    "Jonathan Epstein"
  ],
  [
    "Micheline Epstein"
  ],
  [
    "Orli Etingin",
    "Jonathan Silver"
  ],
  [
    "Steven Feder",
    "Esther Feder"
  ],
  [
    "Drew Feld",
    "Amanda Feld",
    "Abigail Feld",
    "Olivia Feld",
    "Hailey Feld"
  ],
  [
    "Jacqueline Finegoz",
    "Yogev Finegoz"
  ],
  [
    "Jill Franco",
    "Michael Franco"
  ],
  [
    "George Frank",
    "Emily Frank"
  ],
  [
    "Michael Fried",
    "Jennifer Fried"
  ],
  [
    "Hannah Friedman",
    "Joel Belfer"
  ],
  [
    "Neeva Shafiian",
    "Jeremy Garber"
  ],
  [
    "Dana Gelb",
    "Michael Herbstman"
  ],
  [
    "Brian Giebel",
    "Amy Guglielmo"
  ],
  [
    "Rebecca Ginzburg",
    "Alex Ginzburg"
  ],
  [
    "Jay Goldberg",
    "Alyssa Goldberg"
  ],
  [
    "Max Goldberg",
    "Rachel Goldberg"
  ],
  [
    "Andrew Goldman",
    "Susie Miner"
  ],
  [
    "Sam Goldman",
    "Renee Goldman"
  ],
  [
    "Lindsay Goldman",
    "Noah Apter"
  ],
  [
    "Lexi Goldman"
  ],
  [
    "Deanna Goldman",
    "Jeffrey Goldman"
  ],
  [
    "Isabel Goldman",
    "Jake Sirkus"
  ],
  [
    "Sydney Goldman"
  ],
  [
    "Grace Goldman"
  ],
  [
    "Kenny Goldman",
    "Paula Goldman"
  ],
  [
    "Gabrielle Goldman"
  ],
  [
    "Julia Goldman",
    "Drew Haffer"
  ],
  [
    "Scott Goldman"
  ],
  [
    "Rochelle Goldman"
  ],
  [
    "Shelby Gosset",
    "Drew Albera"
  ],
  [
    "Nir Granot",
    "Stephanie Granot"
  ],
  [
    "Stacy Gross",
    "Seth Gross"
  ],
  [
    "Yasemin Gulerman"
  ],
  [
    "Rick Hadley",
    "Phyllis Hadley"
  ],
  [
    "Sarah Halperin",
    "Cole Eiber"
  ],
  [
    "Coleman Hauber",
    "Emily Hauber"
  ],
  [
    "Andrew Helfman",
    "Johanna Goldblatt"
  ],
  [
    "Kenneth Hendel",
    "Julie Hendel"
  ],
  [
    "Scott Henry"
  ],
  [
    "Spencer Herbst",
    "Lindsey Herbst"
  ],
  [
    "Nick Hershey",
    "Molly Pitzele"
  ],
  [
    "Thomas Horey"
  ],
  [
    "Marion Jacobson"
  ],
  [
    "Dinah Jacobson",
    "Ira Jacobson"
  ],
  [
    "Jessica Jalazo",
    "Alex Jalazo"
  ],
  [
    "Suzanne Jurist",
    "Daniel O'Shea"
  ],
  [
    "Allison Perry",
    "Jake Kaminer"
  ],
  [
    "Daniel Kastenbaum",
    "Pam Divack"
  ],
  [
    "Chloe Citron",
    "Jared Katz"
  ],
  [
    "Nancy Katz",
    "Edward Katz"
  ],
  [
    "Dov Keren",
    "Cila Keren"
  ],
  [
    "Martin P Klein",
    "Barbara Klein"
  ],
  [
    "Patrick Knightly"
  ],
  [
    "Cameron Koffman"
  ],
  [
    "Allie Koffman",
    "Jeff Lipsitz"
  ],
  [
    "Jeffrey Koffman",
    "Toni-Anne De Nicola"
  ],
  [
    "Jackson Krase",
    "Bex Krase"
  ],
  [
    "Bonnie Krentzman",
    "Stewart Krentzman"
  ],
  [
    "Max Kuritzky",
    "Ariella Kuritzky",
    "Ozer Kuritzky"
  ],
  [
    "Jeffer Kuritzky",
    "Shira Kuritzky"
  ],
  [
    "Barbara Kuritzky"
  ],
  [
    "Harrison Kuritzky"
  ],
  [
    "Heidi Stetz",
    "Stove Kuritzky"
  ],
  [
    "Benny Kutner",
    "Mira Kutner"
  ],
  [
    "Ian Landau",
    "Risa Landau"
  ],
  [
    "Matthew Landes",
    "Andrea Landes"
  ],
  [
    "Robert Landes",
    "Christina Kretschmer"
  ],
  [
    "Naomi Lefkovits",
    "Lance Lefkovits"
  ],
  [
    "Jack Lerner",
    "Susan Lerner"
  ],
  [
    "Steven Levinson",
    "Naomi Levinson"
  ],
  [
    "Cheryl Lewison",
    "Martin Lewison"
  ],
  [
    "Jon Lim"
  ],
  [
    "Lauren Link",
    "Jon Link"
  ],
  [
    "Ian Lipman",
    "Cat Favino"
  ],
  [
    "Rachel Lobel",
    "Andrew Lobel"
  ],
  [
    "Barbara Loeffel",
    "Henry Loeffel"
  ],
  [
    "Yanni Louka"
  ],
  [
    "Nick Madrid",
    "Abby Quinn"
  ],
  [
    "Sid Mandelbaum",
    "Diane Oshin"
  ],
  [
    "Alexa Mayerhoff",
    "Jacob Toczek"
  ],
  [
    "Andy McCullough",
    "Allison McCullough"
  ],
  [
    "David McDaniel"
  ],
  [
    "Dan Midoneck",
    "Amanda Midoneck"
  ],
  [
    "Ken Midoneck",
    "Stephanie Midoneck"
  ],
  [
    "Estelle Midoneck"
  ],
  [
    "Mitchell Midoneck",
    "Terri Midoneck"
  ],
  [
    "Robert Midoneck",
    "Melody Midoneck"
  ],
  [
    "Robby Mitchell",
    "Sami Mitchell"
  ],
  [
    "Laurey Mogil",
    "Robert Hellman"
  ],
  [
    "Adam Mosenkis",
    "Alyssa Mosenkis"
  ],
  [
    "Steven Nelson",
    "Alexandra Nelson"
  ],
  [
    "Matt O'Donnell",
    "Maddi Stern"
  ],
  [
    "Dvir Ofer",
    "Anna Ofer"
  ],
  [
    "Alex O'Shea",
    "Ari Golin"
  ],
  [
    "Lindsay Ott",
    "Ryan Ott"
  ],
  [
    "Dean Paparian",
    "Lexi Zargar"
  ],
  [
    "Elaine Perry"
  ],
  [
    "Lauren Perry",
    "Philip Spiler"
  ],
  [
    "Jessica Perry",
    "Max Fabricant"
  ],
  [
    "Keren Pickholz"
  ],
  [
    "Steve Pileggi",
    "Sami Pastron"
  ],
  [
    "Sarah Cohen",
    "Steven Pochapin",
    "Adam Pochapin"
  ],
  [
    "Shari Pochapin",
    "Mark Pochapin"
  ],
  [
    "Hana Schwartz",
    "David Pochapin"
  ],
  [
    "Brett Raskin"
  ],
  [
    "Martin Rather"
  ],
  [
    "Gili Remen"
  ],
  [
    "Jackie Rindenow",
    "Matty Rindenow"
  ],
  [
    "Michael Rosen",
    "Stephanie Rosen"
  ],
  [
    "Alec Rosen",
    "Isa Taronto"
  ],
  [
    "Kayla Rosen",
    "Thomas Wright"
  ],
  [
    "Sierra Rosen",
    "Mickl Suave"
  ],
  [
    "Kenny Rubinstein",
    "Esther Rubinstein"
  ],
  [
    "Elliot Schechter",
    "Jennifer Schechter"
  ],
  [
    "Larry Schwartz",
    "Dorit Schwartz"
  ],
  [
    "Jason Schwartz",
    "Adina Schwartz",
    "Harper Schwartz",
    "Zeke Schwartz"
  ],
  [
    "Julia Schwartz"
  ],
  [
    "Penny Schwartz"
  ],
  [
    "Rick Schwartz"
  ],
  [
    "Ella Schwartz"
  ],
  [
    "Freddy Schwartz",
    "Geri Schwartz",
    "Avi Schwartz",
    "Akiva Schwartz",
    "Barak Schwartz",
    "Tifferet Schwartz",
    "Tsofia Schwartz",
    "Ahava Neryah"
  ],
  [
    "Marc Schwartz",
    "Yocheved Schwartz"
  ],
  [
    "Annabelle Schwartz",
    "Andrew Shapiro"
  ],
  [
    "Alan Shapiro",
    "Kim Allis"
  ],
  [
    "Spencer Sigalow",
    "Hannah Sigalow"
  ],
  [
    "Erik Silberstein",
    "Maddie Morris"
  ],
  [
    "Chaim Dovid Siskin",
    "Melissa Siskin",
    "Avraham Yehuda Siskin",
    "Leah Noa Sisken",
    "Yaakov Siskin"
  ],
  [
    "Steven Soffer",
    "Abigail Soffer"
  ],
  [
    "Arnie Stein",
    "Estee Stein"
  ],
  [
    "Kim Stetz"
  ],
  [
    "Ken Sugarman",
    "Bonnie Winston"
  ],
  [
    "Hanna Swerdin",
    "Mack Portnoy"
  ],
  [
    "Jeff Van Demark",
    "Catie Van Demark"
  ],
  [
    "John Varvatos",
    "Joyce Varvatos"
  ],
  [
    "Joe Ventura"
  ],
  [
    "David Wechsler",
    "Terry Wechsler"
  ],
  [
    "David Wood",
    "Elaine Wood"
  ],
  [
    "Alex Yearley",
    "Sydney Yearley"
  ],
  [
    "Alex Yost",
    "Meaghan Yost"
  ],
  [
    "Nina Zaks",
    "Bar Tamir"
  ],
  [
    "Howard Zauderer",
    "Stefanie Zauderer"
  ],
  [
    "Moshe Zauderer"
  ],
  [
    "Samantha Zemser",
    "Matt Jacobs"
  ],
  [
    "Rachel Zemser",
    "Beni Shafer"
  ],
  [
    "Josh Zemser"
  ],
  [
    "Scott Zemser",
    "Amy Zemser"
  ],
  [
    "Lauren Ziemkiewicz",
    "Kein Ziemkiewicz"
  ]
];

export default guestGroups;
